var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-slot-box",class:{ 'is-active': _vm.isActive, disabled: _vm.disabled },on:{"click":function($event){_vm.$emit('input', _vm.nativeValue);
    _vm.$emit('click', $event);}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }